import { render, staticRenderFns } from "./RelatorioPendencias.vue?vue&type=template&id=b4385156"
import script from "./RelatorioPendencias.vue?vue&type=script&lang=js"
export * from "./RelatorioPendencias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports